import styled from '@emotion/styled';
import { Container } from '../../components/Container';
import { media } from '../../services/media';

export const StyledContainer = styled(Container)`
    ${media.max('md')} {
        padding: 40px 15px;
    }
    ${media.min('md')} {
        padding: 80px 15px;
    }
`;
